import React, { useState, useRef } from 'react';
import ReactSVG from 'react-svg';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import SmartPortal from '../SmartPortal';
import CommentFile from './CommentFile';
import { DISPATCH_CONFIG } from './dispatchConfig';
import './styles.scss';

const CommentItem = ({comment, t, objectTypeSelf, objectIdSelf, openEmailHistory, setDispatch, isDisabled, onStateUpdate, onDeleteComment}) => {
  const { 
    commentId,
    text, 
    authorName, 
    date, 
    attachments, 
    published: isPublished,
    published_label,
    editable,
    editableDate,
    removable,
    objectId,
    objectCode,
    objectTypeCode,
    isOwner
  } = comment;

  const [isActionsOpen, setIsActionsOpen] = useState(false); 
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false); 
  const commentType = isPublished ? 'public' : 'internal';

  const elementRef = useRef(null);

  const toggleActionsDropdown = () => {
    setIsActionsOpen(prevState => !prevState);
  };

  const handleActionSelect = (action) => {
    switch(action) {
      case 'edit':
        if (onStateUpdate && typeof onStateUpdate === 'function') {
          onStateUpdate(null);
        }
        setDispatch({...DISPATCH_CONFIG.edit, comment: comment, commentType: commentType});
        break;
      case 'forward':
        if (onStateUpdate && typeof onStateUpdate === 'function') {
          onStateUpdate(null);
        }
        setDispatch({...DISPATCH_CONFIG.forward, comment: comment, commentType: commentType});
        break;
      case 'delete':
        onDeleteComment(comment);
        break;
      case 'history':
        openEmailHistory(commentId);
        break;
      default:
        break;
    }
    setIsActionsOpen(false);
  };

  const renderType = () => {

    const getTypeData = (type) => {
      switch (type) {
        case 'public':
          return {
            modifier: '--public',
            iconSrc: '/data/svg/comments_public.svg',
            text: t('commentSection.publicReply'),
            label: published_label ? ` - ${published_label}` : ``
          };
        case 'internal':
          return {
            modifier: '--internal',
            iconSrc: '/data/svg/comments_internal.svg',
            text: t('commentSection.internalComment'),
            label: null
          };
        default:
          return null;
      }
    };
  
    const typeData = getTypeData(commentType);
  
    if (!typeData) return null;
  
    return (
      <div className={`comment-item__type comment-item__type${typeData.modifier}`}>
        <ReactSVG className="comment-item__type-icon" src={typeData.iconSrc} />
        <div className="comment-item__type-text">{typeData.text}{typeData.label}</div>
      </div>
    );
  };

  const formatDate = (date) => {
    const d = new Date(date);

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); 
    const year = d.getFullYear(); 
    const hours = String(d.getHours()).padStart(2, '0'); 
    const minutes = String(d.getMinutes()).padStart(2, '0'); 

    return `${hours}:${minutes} ${day}.${month}.${year}`;
  };

  const linkTypeMap = {
    INTERACTION_REQUEST: 'appeals',
    TASK: 'order',
    SERVICE: 'service',
    RESOURCE: 'resource'
  };
  
  const buildLinkLabelHref = () => {
    const linkType = linkTypeMap[objectTypeCode];
  
    if (!linkType) {
      console.log(`Link type for objectTypeCode "${objectTypeCode}" does not exist.`);
      return '';
    }
  
    return `#/${linkType}/${objectId}`;
  };
  
  return (
    <div className={`comment-item ${isPublished ? 'comment-item--public' : ''}`}>
      <div className="comment-item__header">

        <div className="comment-item__topsection">
          {renderType()}
          <div className="comment-item__date">{formatDate(date)} {editableDate && `(${t('commentSection.wasEdited')} ${formatDate(editableDate)})`}</div>
        </div>

            
          {/* </SmartPortal> */}

        {/* Kebab Menu */}
          <div className="comment-item__kebab" ref={elementRef}>
            <button
              type="button"
              className={cx("kebab-button", {"kebab-button--open": isActionsOpen})}
              onClick={toggleActionsDropdown}
              aria-haspopup="true"
              aria-expanded={isActionsOpen}
              aria-label="Comment Actions"
            >
              <ReactSVG className="kebab-icon" src="/data/svg/kebab.svg" /> 
            </button>
            {isActionsOpen && (
              <SmartPortal
                portalClassName="portal-comment-item-kebab"
                targetElement={elementRef && elementRef.current}
                portalPlacement="bottom inner-right"
                portalKey={commentId}
                onClickOutside={() => {
                  setIsActionsOpen(false);
                  setIsConfirmDeleteOpen(false)
                }}
                outerOffset={4}
              >
                <div className="kebab-dropdown" role="menu">
                  {editable && (
                    <div 
                      className="kebab-dropdown__option" 
                      onClick={!isDisabled && (() => handleActionSelect('edit'))} 
                    >
                      {t('commentSection.edit')}
                    </div>
                  )}
                  {removable && (
                    <>
                    {/* // <div 
                    //   className="kebab-dropdown__option" 
                    //   onClick={!isDisabled && (() => handleActionSelect('delete'))} 
                    // >
                    //   {t('commentSection.delete')}
                    // </div> */}
                      <div 
                        className="kebab-dropdown__option" 
                        onClick={!isDisabled && (() => setIsConfirmDeleteOpen(true))} 
                      >
                        {t('commentSection.delete')}
                      </div>
                      {isConfirmDeleteOpen && (
                        // <ConfirmDelete
                        // t={t}
                        // commentId={commentId}
                        // commentType={commentType}
                        // onClose={() => setIsConfirmDeleteOpen(false)}
                        // />
                        <div className="kebab-dropdown__confirm-delete">
                          <div className="kebab-dropdown__confirm-delete-text">{t('commentSection.areYouSure')}</div>
                          <div className="kebab-dropdown__confirm-delete-warning">{t('commentSection.deleteWarning')}</div>
                          <div className='kebab-dropdown__confirm-delete-buttons'>
                            <button className='btn-no' onClick={() => setIsConfirmDeleteOpen(false)}>{t('commentSection.no')}</button>
                            <button className='btn-yes' onClick={() => handleActionSelect('delete')}>{t('commentSection.yes')}</button>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                  <div 
                    className="kebab-dropdown__option" 
                    onClick={!isDisabled && (() => handleActionSelect('forward'))} 
                  >
                    {t('commentSection.forward')}
                  </div>
                  <div 
                    className="kebab-dropdown__option" 
                    onClick={() => handleActionSelect('history')} 
                  >
                    {t('commentSection.showHistory')}
                  </div>
                </div>
              </SmartPortal> 
            )}
          </div>
      </div>
      <div className="comment-item__author">{isOwner && <div className="comment-item__author-own"></div>}{authorName}</div>
      {/* <div className="comment-item__author">commentId: {commentId}</div> */}
      
      {attachments && attachments.length > 0 && (
        <div className="comment-item__files">
          {attachments.map((file, index) => (
            <CommentFile key={index} file={file} />
          ))}
        </div>
      )}

      <div className="comment-item__text">
        {text}
      </div>

      {!(objectTypeSelf === objectTypeCode && parseInt(objectIdSelf, 10) === parseInt(objectId, 10)) && (
        <div className="comment-item__linklabels">
          <a className="comment-item__linklabel" href={buildLinkLabelHref()} title={objectCode}>
            <ReactSVG className="comment-item__linklabel-icon" src="/data/svg/comments_linklabel.svg" />
            <div className="comment-item__linklabel-text">{objectCode}</div>
          </a>
        </div>
      )}
    </div>
  );
};

export default (withTranslation()(CommentItem));
